import { Component, ElementRef, Injector, Renderer2 } from '@angular/core';
import {
    AbstractControlOptions,
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { SignUpService } from 'src/app/shared/services/auth-service/sign-up.service';
import { RegexEnum } from 'src/app/shared/global/regex-enum';
import * as CryptoJS from 'crypto-js';

import { CountryISO } from 'ngx-intl-tel-input';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent {
    CountryISO = CountryISO;
    preferredCountries: CountryISO[] = [CountryISO.India];
    emailExist = false;
    company_id: any;
    mail: any;
    public log: string[] = [];
    signUpForm!: FormGroup;
    public showPassword = false;
    public confirmShowPassword = false;
    user: any;
    source: any;
    userArr: Array<{
    first_name: string;
    last_name: string;
    email: string;
    mobile_number: number;
    password: string;
    confirm_password: string;
  }> = [];
    patchMailSignUp = false;
    // routing prams for signup for outsider user
    routingParms: any;
    subscription: Subscription;
    constructor(
    private recaptchaV3Service: ReCaptchaV3Service,
    private formBuilder: FormBuilder,
    private router: Router,
    private injector: Injector,
    private signUpService: SignUpService,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2, private el: ElementRef
    ) {}

    ngOnInit(): void {
        this.initializeFrom();
        this.subscription = this.signUpService.userEmail.subscribe((data) => {
            this.mail = data;
            this.userArr = [];
        });

        this.activatedRoute.queryParams.subscribe(async (params: any) => {
            this.source = params.source;
            this.routingParms = params;
            if (params.email) {
                this.signUpForm.get('email').setValue(params.email);
                this.patchMailSignUp = true;
            }
            if ((this.company_id == params['id'])) {
                this.company_id = params['id']?.replaceAll(' ', '+');
                this.company_id = CryptoJS.AES.decrypt(
                    this.company_id?.trim(),
                    ''
                ).toString(CryptoJS.enc.Utf8);
                this.company_id = parseInt(this.company_id);
            }
        });
        if(window.origin.includes('app.taskopad.com')){
            this.loadClarityScript();
        }
    }

    initializeFrom() {
        this.signUpForm = this.formBuilder.group(
            {
                first_name: [
                    '',
                    [
                        Validators.required,
                        Validators.pattern('[a-zA-Z ]*'),
                        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
                    ],
                ],
                last_name: [
                    '',
                    [
                        Validators.required,
                        Validators.pattern('[a-zA-Z ]*'),
                        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
                    ],
                ],
                email: [
                    '',
                    [
                        Validators.required,
                        Validators.email,
                        Validators.pattern(RegexEnum.email),
                    ],
                ],
                mobile_number: ['', Validators.required],
                isd_code: ['', [Validators.required]],
                password: [
                    '',
                    [
                        Validators.required,
                        Validators.pattern(RegexEnum.passwordValidation),
                    ],
                ],
                confirmPassword: ['', [Validators.required]],
                recaptcha: ['', Validators.required],
            },
      {
          validator: this.ConfirmedValidator('password', 'confirmPassword'),
      } as AbstractControlOptions
        );
    }

    ConfirmedValidator(controlName: string, matchingControlName: string) {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];
            if (
                matchingControl.errors &&
        !matchingControl.errors['confirmedValidator']
            ) {
                return;
            }
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ confirmedValidator: true });
            } else {
                matchingControl.setErrors(null);
            }
        };
    }

    public addTokenLog(message: string, token: string | null) {
        this.signUpForm.controls['recaptcha'].setValue(token);
        this.log.push(`${message}: ${this.formatToken(token)}`);
    }
    public formatToken(token: string | null) {
        return token !== null
            ? `${token.substring(0, 7)}...${token.substring(-7)}`
            : 'null';
    }
    public printLog() {
        return this.log
            .map((logEntry, index) => `${index + 1}. ${logEntry}`)
            .join('\n');
    }

    public togglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }

    public toggleConfirmPasswordVisibility(): void {
        this.confirmShowPassword = !this.confirmShowPassword;
    }
    changeCountryCode(e: any) {
        this.signUpForm.get('isd_code').setValue('+' + e.dialCode);
    }

    async submit() {
        if (this.signUpForm.invalid) {
            return this.signUpForm.markAllAsTouched();
        }
        const data = JSON.parse(JSON.stringify(this.signUpForm.value));
        data.mobile_number = data.mobile_number.replace(data.isd_code, '');
        data['source'] = this.source;
        if (this.patchMailSignUp) {
            data.outsider = true;
            data.inviteToken = this.routingParms.inviteToken;
        }
        delete data.recaptcha;
        (
            await this.signUpService.signUp({
                data: data,
                recaptcha: this.signUpForm.value.recaptcha,
                company_id: this.company_id,
            })
        ).subscribe((dataRes) => {
            if (dataRes[0] !== 'error') {
                this.signUpService.getEmail(this.signUpForm.value.email);
                this.router.navigate(['/acknowledge']);
            }
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    loadClarityScript() {
        const script = this.renderer.createElement('script');
        script.type = 'text/javascript';
        script.text = `
          (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "muwea7hyun");
        `;
        this.renderer.appendChild(this.el.nativeElement, script);
      }
}
